import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components/macro';

import { OpenWfDetails } from 'models/response';

import utils from 'utils';
import actions from 'state/actions';
import selectors from 'state/selectors';

import CommonButton from 'components/Buttons/CommonButton';
import { Header } from 'components/Modal';

export const ButtonContainer = styled.div`
  margin-top: 10px;
  text-align: center;
  button {
    margin: 10px;
  }
`;

const ShowSapData = () => {
  const dispatch = useDispatch();
  const t = utils.intl.useTranslator();
  const modalProps = useSelector(selectors.modal.getModalProps) as {
    message: string;
    sendToWfData?: OpenWfDetails;
    endExecution?: () => void;
    openSendToWf?: (data: OpenWfDetails) => void;
  };
  const translate = utils.app.textTranslated;

  return (
    <>
      <Header title={t('sap_data_title')} subtitle={translate(modalProps.message, t)} />
      <ButtonContainer>
        <CommonButton
          id="continue-btn"
          value={t('continua')}
          action={() => {
            if (modalProps.endExecution) {
              modalProps.endExecution();
              dispatch(actions.modal.closeModal());
            } else if (modalProps.openSendToWf && modalProps.sendToWfData) {
              modalProps.openSendToWf(modalProps.sendToWfData);
            }
          }}
        />
      </ButtonContainer>
    </>
  );
};

export default ShowSapData;
